export default [
  {
    type: 'ColumnSet',
    columns: [
      {
        type: 'Column',
        width: 'auto',
        items: [
          {
            type: 'TextBlock',
            text: '{{objectType}}: ',
            weight: 'Bolder',
            isSubtle: true,
            fontType: 'Default',
            spacing: 'None',
            wrap: true,
          },
        ],
      },
      {
        type: 'Column',
        width: 'auto',
        items: [
          {
            type: 'TextBlock',
            text: '{{objectName}}',
            spacing: 'None',
          },
        ],
      },
    ],
    style: 'default',
    bleed: true,
  },
  {
    type: 'Container',
    items: [
      {
        type: 'TextBlock',
        text: 'Created {{createWhen}}',
        wrap: true,
        isSubtle: true,
        weight: 'bolder',
        size: 'small',
        spacing: 'None',
      },
    ],
  },
];
